import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';
import { UserService } from '@core/services/user.service';

export const MembershipGuard: CanActivateFn = async (route, state) => {

	const userService = inject(UserService);
	const cookieService = inject(CookieService);

	if (userService.getToken() || cookieService.get('kwo_allow_visit')) {

		return true;
	}

	cookieService.set('kwo_allow_visit', 'true', 1);
	inject(Router).navigate(['membership']);

	return false;
};